import { RootState } from "../types";


export const selectSidebarPermissionStatus = (state: RootState) => state.sidebarMenu.sidebarPermissionStatus;
